<template>
    <div ref="log" class="chat-log">
        <!-- Written here rather than fetched: opening a conversation is a
             local reset, so the first thing in the log is always ours. It stays
             at the top once the talking starts, the way a greeting does. -->
        <AssistantMessageBubble :message="greeting" />

        <AssistantMessageBubble
            v-for="(message, index) in messages"
            :key="index"
            :message="message"
            :is-dictated="message.isDictated"
        />

        <AssistantMessageBubble
            v-if="outgoing"
            :message="outgoingMessage"
            :is-dictated="outgoing.isDictated"
            :is-pending="!outgoing.content"
        />

        <div v-if="isSending" class="chat-log__working">
            <v-progress-circular
                indeterminate
                size="18"
                width="2"
                color="#967adc"
            ></v-progress-circular>
            <span>{{ $t('pages.assistant.composer.working') }}</span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AssistantMessageBubble from './assistant-message-bubble.vue'
import { assistantGetterTypes } from '@/store/modules/assistant/types'
import { ASSISTANT_MESSAGE_ROLES } from '@/consts/assistant'

export default {
    name: 'AssistantChatLog',
    components: { AssistantMessageBubble },
    computed: {
        ...mapGetters('assistant', {
            messages: assistantGetterTypes.GET_MESSAGES,
            outgoing: assistantGetterTypes.GET_OUTGOING,
            isSending: assistantGetterTypes.GET_IS_SENDING,
        }),
        greeting: function () {
            return {
                role: ASSISTANT_MESSAGE_ROLES.ASSISTANT,
                content: this.$t('pages.assistant.chat.greeting'),
            }
        },
        outgoingMessage: function () {
            return {
                role: ASSISTANT_MESSAGE_ROLES.USER,
                content: this.outgoing.content,
            }
        },
    },
    watch: {
        messages: function () {
            this.scrollToEnd()
        },
        outgoing: function () {
            this.scrollToEnd()
        },
    },
    mounted() {
        this.scrollToEnd()
    },
    methods: {
        scrollToEnd: function () {
            this.$nextTick(() => {
                const log = this.$refs.log

                if (log) log.scrollTop = log.scrollHeight
            })
        },
    },
}
</script>

<style scoped lang="scss">
.chat-log {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding: 16px;
    flex-grow: 1;

    &__working {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #8a8f94;
        font-size: 12px;
        padding: 4px 0;
    }
}
</style>
